"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveillanceInitialImpl = void 0;
const utils_1 = require("../utils");
const luxon_1 = require("luxon");
class SurveillanceInitialImpl {
    constructor(bilan) {
        this.format = (elem, custom = []) => {
            const temp = [null, undefined, 'u', ...custom].includes(elem) ? null : elem;
            if (temp)
                this.isEmpty = false;
            return temp;
        };
        this.formatOnly = (elem, custom = []) => ([null, undefined, 'u', ...custom].includes(elem) ? null : elem);
        this.formatZero = (elem, custom = []) => {
            const temp = [null, undefined, 'u', ...custom].includes(elem) ? null : elem === 0 ? '0' : elem;
            if (temp)
                this.isEmpty = false;
            return temp;
        };
        this.type = 'surveillance';
        this.index = -1;
        this.date = bilan?.equipe.heure_arrivee_intervention || bilan?.intervention.created_at
            ? luxon_1.DateTime.fromISO(bilan?.equipe.heure_arrivee_intervention || bilan?.intervention.created_at)
                .setZone('Europe/Paris')
                .setLocale('fr-fr')
            : null;
        this.heure =
            luxon_1.DateTime.fromISO(bilan?.equipe.heure_arrivee_intervention || bilan?.intervention.created_at)
                .setZone('Europe/Paris')
                .setLocale('fr-fr')
                .toFormat('HH') ?? '--';
        this.minute =
            luxon_1.DateTime.fromISO(bilan?.equipe.heure_arrivee_intervention || bilan?.intervention.created_at)
                .setZone('Europe/Paris')
                .setLocale('fr-fr')
                .toFormat('mm') ?? '--';
        this.isEmpty = true;
        this.o2aa = this.formatZero(bilan.respiration.o2aa, [...utils_1.EMPTY_STRING_ARRAY, ...utils_1.NEGATIVE_ARRAY]);
        this.o2o2 = this.formatZero(bilan.respiration.o2o2, [...utils_1.EMPTY_STRING_ARRAY, ...utils_1.NEGATIVE_ARRAY]);
        this.debit_o2 = this.format(bilan.geste.inha, [...utils_1.EMPTY_STRING_ARRAY, ...utils_1.ZERO_ARRAY]);
        this.spo2_with_o2 = null;
        this.oxy_debit = null;
        this.oxy_debit_unit = null;
        this.dispositif_oxygeno = bilan.geste.dispositif_oxygeno;
        this.inconscience = this.formatZero(bilan.neurologique.inconscience);
        this.fr = this.formatZero(bilan.respiration.fv, [...utils_1.NEGATIVE_ARRAY, ...utils_1.EMPTY_STRING_ARRAY]);
        this.spco =
            this.formatZero(bilan.respiration.spco_decimal, [...utils_1.NEGATIVE_ARRAY, ...utils_1.EMPTY_STRING_ARRAY]) ||
                this.formatZero(bilan.respiration.spco, [...utils_1.NEGATIVE_ARRAY, ...utils_1.EMPTY_STRING_ARRAY]);
        this.etco2 = this.formatZero(bilan.respiration.etco2);
        this.peak_flow = this.formatZero(bilan.respiration.peak_flow);
        this.respirateur_fr = null;
        this.respirateur_fio2 = null;
        this.respirateur_vt = null;
        this.respirateur_pep = null;
        this.fc = this.formatZero(bilan.circulatoire.fc, [...utils_1.NEGATIVE_ARRAY, ...utils_1.EMPTY_STRING_ARRAY]);
        this.fc_type = null;
        this.pabd = this.formatZero(bilan.circulatoire.tension_droite, [...utils_1.NEGATIVE_ARRAY, ...utils_1.EMPTY_STRING_ARRAY]);
        this.pambd = null;
        this.pabg = this.formatZero(bilan.circulatoire.tension_gauche, [...utils_1.NEGATIVE_ARRAY, ...utils_1.EMPTY_STRING_ARRAY]);
        this.pambg = null;
        this.pamd = (0, utils_1.computePam)(bilan.circulatoire.tension_droite) || null;
        this.pamg = (0, utils_1.computePam)(bilan.circulatoire.tension_gauche) || null;
        this.is_pam_entry_by_user = null;
        this.tension_moyenne = this.formatZero(bilan.circulatoire?.tension_moyenne, [
            ...utils_1.NEGATIVE_ARRAY,
            ...utils_1.EMPTY_STRING_ARRAY,
        ]);
        this.tension_manuelle_systolique = this.formatZero(bilan.circulatoire?.tension_manuelle_systolique, [
            ...utils_1.NEGATIVE_ARRAY,
            ...utils_1.EMPTY_STRING_ARRAY,
        ]);
        this.tension_manuelle_systolique_gauche = this.formatZero(bilan.circulatoire?.tension_manuelle_systolique_gauche, [
            ...utils_1.NEGATIVE_ARRAY,
            ...utils_1.EMPTY_STRING_ARRAY,
        ]);
        this.tension_manuelle_systolique_droite = this.formatZero(bilan.circulatoire?.tension_manuelle_systolique_droite, [
            ...utils_1.NEGATIVE_ARRAY,
            ...utils_1.EMPTY_STRING_ARRAY,
        ]);
        this.hemoglobine = this.formatZero(bilan.medic_info.hemoglobine, [...utils_1.NEGATIVE_ARRAY, ...utils_1.NEGATIVE_FLOAT_ARRAY]);
        this.hemocue = null;
        this.shockIndex = null;
        this.choc_date = null;
        this.choc_time = null;
        this.nb_choc_total = null;
        this.choc_index = this.formatZero(bilan.medic_info.choc_index, [...utils_1.NEGATIVE_ARRAY, ...utils_1.NEGATIVE_FLOAT_ARRAY]);
        this.pupilles = this.format(bilan.medic_info.pupilles, [...utils_1.EMPTY_STRING_ARRAY, ...utils_1.ZERO_ARRAY]);
        this.pupilles_bilateral = this.formatZero(bilan.medic_info.pupilles_bilateral, [...utils_1.EMPTY_STRING_ARRAY]);
        this.glasgow = null;
        this.gla_yeux = this.format(parseInt(bilan.medic_info.gla_yeux, 10), [...utils_1.NEGATIVE_ARRAY, ...utils_1.ZERO_ARRAY]);
        this.gla_parole = this.format(parseInt(bilan.medic_info.gla_parole, 10), [...utils_1.NEGATIVE_ARRAY, ...utils_1.ZERO_ARRAY]);
        this.gla_motricite = this.format(parseInt(bilan.medic_info.gla_motricite, 10), [...utils_1.NEGATIVE_ARRAY, ...utils_1.ZERO_ARRAY]);
        this.glycemie = this.formatZero(bilan.medic_info.glycemie, [...utils_1.NEGATIVE_ARRAY, ...utils_1.NEGATIVE_FLOAT_ARRAY]);
        this.glycemie_unite = this.formatOnly(bilan.medic_info.glycemie_unite, [
            ...utils_1.NEGATIVE_ARRAY,
            ...utils_1.NEGATIVE_FLOAT_ARRAY,
        ]);
        this.avpu = this.formatZero(bilan.neurologique.avpu, [...utils_1.NEGATIVE_ARRAY]);
        this.hbco = this.formatZero(bilan.respiration.hbco, [...utils_1.NEGATIVE_ARRAY]);
        this.trc = null;
        this.paleur = null;
        this.score_sedation = null;
        this.hemoglobine_float = this.formatZero(bilan.medic_info.hemoglobine, [...utils_1.NEGATIVE_ARRAY, ...utils_1.NEGATIVE_FLOAT_ARRAY]);
        this.temperature = this.formatZero(bilan.neurologique.temperature, [...utils_1.NEGATIVE_ARRAY, ...utils_1.NEGATIVE_FLOAT_ARRAY]);
        this.temperature_zone = this.format(bilan.neurologique?.temperature_zone_select, [
            ...utils_1.EMPTY_STRING_ARRAY,
            utils_1.ZERO_ARRAY,
            ...utils_1.NEGATIVE_ARRAY,
            ...utils_1.NEGATIVE_FLOAT_ARRAY,
        ]);
        this.eva = this.formatZero(bilan.circonstance.severite, [...utils_1.NEGATIVE_ARRAY]);
        this.comment = null;
        this.apgar_score = null;
        this.malinas = null;
        this.nihss = null;
        this.apgar = {
            fc: null,
            fr: null,
            tonus: null,
            reactivite: null,
            coloration: null,
        };
        this.obst = {
            malinas_parite: null,
            malinas_travail: null,
            malinas_duree_contraction: null,
            malinas_intervalle_contraction: null,
            malinas_perte_eaux: null,
            nombre_pars: null,
            duree_contractions: null,
            intervalle_contraction: null,
            intervalle_contraction_sec: null,
            contraction: null,
            perte_eaux: null,
        };
    }
}
exports.SurveillanceInitialImpl = SurveillanceInitialImpl;
